import * as React from "react";
import { useEffect, useRef, useState } from "react";
import AppBar from "@mui/material/AppBar";
import Toolbar from "@mui/material/Toolbar";
import Typography from "@mui/material/Typography";
import CssBaseline from "@mui/material/CssBaseline";
import Box from "@mui/material/Box";
import Container from "@mui/material/Container";
import { useParams } from "react-router-dom";
import useFetch from "../../hooks/useFetch";
import { BASE_URL } from "../../constants";
import { reportErrors } from "../../helpers";
import {
  Button, CardMedia,
  Divider,
  FormControl,
  FormLabel,
  Radio,
  RadioGroup,
  Stack,
} from "@mui/material";
import FormControlLabel from "@mui/material/FormControlLabel";
import InputField from "../../components/InputField";
import AlertBar from "../../components/AlertBar";

export default function PropertyRateReview(props) {
  const { propertyId } = useParams();
  const alert = useRef();
  const [data, setData] = useState([]);
  const [canSubmit, setCanSubmit] = useState(true);
  const { data: details } = useFetch(
    `get-property-review-details/${propertyId}`,
    null,
    true,
    [],
    (response) => response.data.data
  );

  useEffect(() => {
    loadData();
  }, [details]);
  const loadData = () => {
    let url = `${BASE_URL}get-review-form/${details?.companyId}?businessType=${details?.businessType}`;
    window.axios
      .get(url)
      .then((response) => {
        setData(response.data.data);
      })
      .catch((error) => {
        reportErrors(alert.current, error);
      });
  };

  const handleChange = (event, questionId) => {
    setData(
      data.map((e) => {
        if (e.questionId === questionId) e.answers = event.target.value;
        return e;
      })
    );
  };

  const handleChangeTextResult = (value, questionId) => {
    setData(
      data.map((e) => {
        if (e.questionId === questionId) e.answers = value;
        return e;
      })
    );
  };

  const submit = (otherReview) => {
    let formData = {
      businessType: details?.businessType,
      questions: data,
      companyId: details?.companyId,
      otherReview,
    };
    if (canSubmit) {
      setCanSubmit(false);
      window.axios
        .post(`${BASE_URL}post-review-form`, formData)
        .then((response) => {
          setCanSubmit(true);
          if (otherReview === "google") {
            window.open(details?.google_url, "_self");
          } else {
            window.open(details?.tripadvisor_url, "_self");
          }
        })
        .catch((error) => {
          setCanSubmit(true);
          reportErrors(alert.current, error);
        });
    }
  };

  return (
    <React.Fragment>
      <CssBaseline />
      <AppBar>
        <Toolbar>
          <Typography variant="h6" component="div">
            {details?.company?.name}
          </Typography>
        </Toolbar>
      </AppBar>
      <Toolbar />
      <Container>
        <Box sx={{ my: 2 }}>
          <CardMedia
              component="img"
              image={`data:image/png;base64, ${details?.banner}`}
              alt={"alt"}
              sx={{objectFit: "fill"}}
          />
          <AlertBar ref={alert} />
          <Stack spacing={2} sx={{ p: 2 }}>
            <Typography variant="h6" component="div">
              Rate Review
            </Typography>
            <Divider />
            {data.map((e, index) =>
              e.questionType === "Radio" ? (
                <FormControl key={e.questionId}>
                  <FormLabel id="demo-row-radio-buttons-group-label">
                    {index + 1}. {e.name}
                  </FormLabel>
                  <RadioGroup
                    aria-labelledby="demo-row-radio-buttons-group-label"
                    name="row-radio-buttons-group"
                    onChange={(event) => handleChange(event, e.questionId)}
                  >
                    {e.choises.map((c) => (
                      <FormControlLabel
                        sx={{ pl: 2 }}
                        value={`${c.answer?.name}`}
                        control={<Radio />}
                        label={`${c.answer?.name}`}
                      />
                    ))}
                  </RadioGroup>
                </FormControl>
              ) : (
                <InputField
                  key={e.questionId}
                  required={true}
                  label={`${index + 1}. ${e.name}`}
                  type="text"
                  multiline={true}
                  onChange={(value) =>
                    handleChangeTextResult(value, e.questionId)
                  }
                />
              )
            )}
            {data.length > 0 && (
              <>
                <Button
                  disableElevation
                  sx={{ textTransform: "none" }}
                  fullWidth
                  size="medium"
                  variant="contained"
                  color="primary"
                  onClick={() => submit("google")}
                >
                  Google Review
                </Button>
                <Button
                  disableElevation
                  sx={{ textTransform: "none" }}
                  fullWidth
                  size="medium"
                  variant="contained"
                  color="secondary"
                  onClick={() => submit("tripadvisor")}
                >
                  Tripadvisor Review
                </Button>
              </>
            )}
          </Stack>
        </Box>
      </Container>
    </React.Fragment>
  );
}
